// src/features/records/components/ViewSelector.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { FileText, CheckSquare, Calendar, MapPin, Image, Waypoints } from 'lucide-react';
import styles from './ViewSelector.module.css';

const ViewSelector = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  
  const views = [
    { id: 'note', key: 'note', icon: FileText, path: '/records/notes' },
    { id: 'task', key: 'task', icon: CheckSquare, path: '/records/tasks' },
    { id: 'calendar', key: 'calendar', icon: Calendar, path: '/records/calendar' },
    { id: 'map', key: 'map', icon: MapPin, path: '/records/map' },
    { id: 'gallery', key: 'gallery', icon: Image, path: '/records/gallery' },
    { id: 'graph', key: 'graph', icon: Waypoints, path: '/records/graph' },
  ];

  const currentView = views.find(view => location.pathname === view.path)?.id || 'note';

  const handleViewChange = (path) => {
    navigate(path);
  };

  return (
    <div className={styles.viewSelector}>
      {views.map(view => {
        const Icon = view.icon;
        const isActive = currentView === view.id;
        const label = t(`records.shell.views.${view.key}`);
        
        return (
          <button
            key={view.id}
            className={`${styles.viewTab} ${isActive ? styles.active : ''}`}
            onClick={() => handleViewChange(view.path)}
            aria-label={t('records.shell.view_tab_aria', { view: label })}
          >
            <Icon className={styles.viewTabIcon} size={20} />
            <span className={styles.viewTabText}>{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ViewSelector;
